/**
 * Типы баланса, которые тратятся на генерацию песни. Бэк при списании считает
 * их СУММОЙ: разовые `songs` (legacy-имя — `full_songs`) плюс подписочные
 * `subscription_songs`. Считаем так же — иначе подписчик с 30 песнями по
 * подписке видел бы «0 песен» и упирался в «недостаточно баланса».
 */
const SONGS_BALANCE_TYPES = new Set(["songs", "full_songs", "subscription_songs"]);
/**
 * Баланс песен из массива балансов ответа `/users/me`
 * (`balances: [{ type: "songs", amount }]`). Регистр типа не важен; не массив
 * или битые записи → 0.
 */
export function extractSongsBalance(items) {
    if (!Array.isArray(items))
        return 0;
    return items.reduce((sum, item) => {
        const type = String(item?.type ?? "").toLowerCase();
        const amount = Number(item?.amount);
        return SONGS_BALANCE_TYPES.has(type) && Number.isFinite(amount)
            ? sum + amount
            : sum;
    }, 0);
}
